import type { PropType } from "vue";

import type { Color, Size } from "@/lib/components/types";
import type { InputValue } from "@/lib/helpers/types";

const type = {
  type: String as PropType<"email" | "number" | "password" | "text">,
  default: "text",
  validator: (value: string) =>
    ["text", "email", "password", "number"].includes(value),
};

type PrimitiveOrArrayValue = InputValue<
  boolean | number | string | readonly (boolean | number | string)[]
>;
const primitiveOrArrayValue = {
  type: [String, Number, Array, Boolean] as PropType<PrimitiveOrArrayValue>,
  default: null,
};

const size = {
  type: String as PropType<Size>,
  default: "md",
  required: false,
};

const decimals = { type: [Boolean, String, Number], default: false };
type Decimals = boolean | number | string;

const color = {
  type: String as PropType<Color>,
  default: "warning",
  validator: (colorValue: string) =>
    ["primary", "accent", "success", "warning", "danger", "gray"].includes(
      colorValue,
    ),
};

export type { Decimals, PrimitiveOrArrayValue };
export { color, decimals, primitiveOrArrayValue, size, type };
